import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './components/Toast';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import CreateTest from './pages/admin/CreateTest';
import TestDetail from './pages/admin/TestDetail';
import CandidateDetail from './pages/admin/CandidateDetail';
import CandidatesList from './pages/admin/CandidatesList';
import JoinExam from './pages/candidate/JoinExam';
import TakeExam from './pages/candidate/TakeExam';
import ExamComplete from './pages/candidate/ExamComplete';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
      <div className="app">
        <Routes>
          <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/create-test" element={<CreateTest />} />
          <Route path="/admin/test/:id" element={<TestDetail />} />
          <Route path="/admin/candidates" element={<CandidatesList />} />
          <Route path="/admin/candidate/:id" element={<CandidateDetail />} />
          <Route path="/exam/:slug" element={<JoinExam />} />
          <Route path="/exam/:slug/take" element={<TakeExam />} />
          <Route path="/exam/:slug/complete" element={<ExamComplete />} />
        </Routes>
      </div>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
